import React, { useId } from 'react';
import Switch from '../nucleus/Switch';
import './Toggle.css';

// A switch with its words: the platform's one switch (components/nucleus/Switch.js),
// a label and a line beside it. Pressing the words flips it too.
const Toggle = ({
  checked = false,
  onChange,
  label,
  description,
  disabled = false,
}) => {
  const id = useId();
  return (
    <div className={`p-toggle ${disabled ? 'p-toggle--disabled' : ''}`}>
      <Switch id={id} checked={checked} onChange={onChange} disabled={disabled} aria-label={typeof label === 'string' ? label : undefined} />
      {(label || description) && (
        <label className="p-toggle__text" htmlFor={id}>
          {label && <span className="p-toggle__label">{label}</span>}
          {description && <span className="p-toggle__description">{description}</span>}
        </label>
      )}
    </div>
  );
};

export default Toggle;
